import React from 'react';

export default () => (
  <div>
    <p>
      A collection of <a href="https://www.ansible.com/">Ansible</a>
      {' '}playbooks and <a href="https://www.gnu.org/software/bash/">Bash</a> scripts
      {' '}that I use to setup <a href="https://www.debian.org/">Debian</a>
      {' '}servers with focus on security.
      {' '}I also used a little bit of <a href="https://www.python.org/">Python</a>.
    </p>

    <p>
      Repos: I'm not too comfortable sharing the code for this project. I'll do a demo if so desired.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/Debian.js